import type { RouterProviderProps } from "react-router-dom";
import { RouterProvider } from "react-router-dom";
import { memo, useMemo } from "react";

import { useRole } from "@/stores/userStore";
import { getRouter } from "@routes/router.tsx";

export const AppRouter = memo(function AppRouter(
  props: Omit<RouterProviderProps, "router">,
) {
  const role = useRole();

  const router = useMemo(() => {
    return getRouter(role);
  }, [role]);

  return <RouterProvider router={router} {...props} />;
});
